<template>
  <div class="photo-wall">
    <!-- 照片墙 -->
    <div class="photo-row">
      <div class="photo-item" v-for="(image, index) in images" :key="index">
        <img :src="image" alt="Photo" class="photo" @click="showImage(image)" />
      </div>
    </div>

    <!-- 放大的照片弹窗 -->
    <div v-if="showModal" class="modal" @click="closeModal">
      <img :src="currentImage" alt="Enlarged Photo" class="enlarged-photo" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Activities",
  data() {
    return {
      images: [
        require("../assets/memory6.jpg"),
        require("../assets/memory7.jpg"),
        require("../assets/memory5.jpg"),
        require("../assets/memory4.jpg"),
        require("../assets/memory2.jpg"),
        require("../assets/memory1.jpg"),
        require("../assets/all_people.jpg"),
        require("../assets/all_people1.jpg"),
      ],
      showModal: false, // 控制弹窗显示
      currentImage: "", // 当前被点击的图片
    };
  },
  methods: {
    showImage(image) {
      this.currentImage = image; // 设置当前图片
      this.showModal = true; // 打开弹窗
    },
    closeModal() {
      this.showModal = false; // 关闭弹窗
      this.currentImage = ""; // 清空当前图片
    },
  },
};
</script>

<style scoped>
/* 照片墙外层 */
.photo-wall {
  width: 1000px;
  margin: auto;
  display: flex;
  justify-content: center;
  padding: 20px;
}

/* 每一行照片的容器 */
.photo-row {
  display: flex;
  flex-wrap: wrap; /* 自动换行 */
  justify-content: center; /* 不足四张时居中对齐 */
  gap: 20px; /* 照片之间的间距 */
  max-width: 1200px; /* 设置最大宽度（调整整体宽度） */
}

/* 单张照片的框样式 */
.photo-item {
  width: 300px; /* 固定宽度 */
  height: 250px; /* 固定高度 */
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden; /* 隐藏溢出部分 */
  border: 2px solid #ddd; /* 可选：给框加边框 */
  border-radius: 8px; /* 可选：让框的边角圆滑 */
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); /* 可选：加阴影效果 */
}

/* 照片样式 */
.photo {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 保持图片比例，填充整个框 */
  cursor: pointer;
  transition: transform 0.3s ease;
}

.photo:hover {
  transform: scale(1.05);
}

/* 弹窗样式 */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  cursor: pointer;
}

.enlarged-photo {
  max-width: 90%;
  max-height: 90%;
  border-radius: 10px;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.3);
}

/* 针对小屏幕的响应式样式 */
@media screen and (max-width: 768px) {
  .photo-wall {
    width: 80%;
    margin: auto;
    display: flex;
    justify-content: center;
    padding: 20px;
  }

  .photo-item {
    width: 300px; /* 在小屏幕上缩小框的大小 */
    height: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components2/Activities.vue